import Store from "util/store"
import { Graphics, DisplayMode } from "common/enums"
import _ from 'lodash'
import { removeClass, addClass, hasClass } from 'util/dom'
import { isContain } from 'util/vector'

export class WriteBoard{
  constructor (painter, pageStore) {
    // super(params)
    this.painter = painter
    this.pageStore = pageStore
    this.render = this.painter.render
    this.userId = Store.userInfo.userId
    this.parttern = {}
   
    this.getGraphId()
    
    // 选择的线条
    this.graphChildren = []
    // 包围盒对象
    this.boundingRect = null
    // 选择对象移动状态
    this.moveStatus = false

    this.addEvents()
  }
  // 获取图元id
  getGraphId () {
    return ((this.userId << 16) | this.pageStore.graphIdSeed ++)
  }
  /**
   * canvas添加相关事件
   */
  addEvents () {
   this.painter.text.onblur = this._inputBlurHandle.bind(this)
   this.painter.text.oninput = this._inputChangeHandle.bind(this)
   this.painter.canvasEle.onmousedown = (e) => {
      if (!this.pageStore.editConfig.status) return
      this.rate = this.painter.width / this.painter.canvasWidth
      // console.log(this.rate, this.rate)
      let canvasDis = this._calcXY(e.offsetX, e.offsetY)
      // 橡皮檫处理
      if (this.pageStore.shape === Graphics.ERASER) {
        let pageData = this.pageStore.findPagePaints(this.pageStore.getCurPage())
        // 遍历查找点是否在线上
        let paints = this.pageStore.findPaintsByPoint(pageData, canvasDis)
        if (paints) {
          this.painter._sendGraphMsg(paints.type, paints[paints.type], 3)
          this._storeStack(paints.type, paints[paints.type])
        }
        return
      }
      // 文字处理
      if (this.pageStore.shape === Graphics.TEXT) {
        if (!hasClass(this.painter.canvasManager.textEle, 'hidden')) return
        // fix:bug mousedown事件 比 blur事件先触发  输入框消失后触发事件不重新覆盖对象
        this._createShapeObject()
        removeClass(this.painter.canvasManager.textEle, 'hidden')
        let disstance = this._calcTextDisance(e.offsetX, e.offsetY)
        this.painter.canvasManager.textEle.style.top = disstance.y + 'px'
        this.painter.canvasManager.textEle.style.left = disstance.x + 'px'
        this.painter.canvasManager.textEle.style.transformOrigin = 'left top'
        this.painter.canvasManager.textEle.style.transform = `scale3d(${1 / this.rate}, ${1 / this.rate}, 1)`
        this.painter.canvasManager.textEle.style.fontSize = 20 + 'px'
        this.parttern.left = canvasDis.x
        this.parttern.top = canvasDis.y
        this.painter.text.value = ''
        setTimeout(() => {
         this.painter.text.focus()
        }, 100)
        return
      }
      this._createShapeObject()
      // 移动处理
      if (this.pageStore.shape === Graphics.GMOV) {
        this.moveStatus = isContain(this.boundingRect, canvasDis) && this.graphChildren.length > 0
        this.boundingRect = null
      }
      // 直线处理
      if (this.pageStore.shape === Graphics.LINE) {
        this.parttern.x1 = canvasDis.x
        this.parttern.y1 = canvasDis.y
        this.parttern.x2 = canvasDis.x
        this.parttern.y2 = canvasDis.y
        this.painter._sendGraphMsg(this.pageStore.shape, this.parttern, 1)
      }
      // 曲线处理
      if (this.pageStore.shape === Graphics.CURVE) {
        this.parttern.points.push([canvasDis.x, canvasDis.y])
        this.painter._sendGraphMsg(this.pageStore.shape, this.parttern, 1)
      }
      document.onmousemove = (e) => {
        _.throttle(() => {
          const {x: endx, y: endy} = this._calcXY(e.offsetX, e.offsetY)
          
          if (this.pageStore.shape === Graphics.LINE) {
            this.parttern.x2 = endx
            this.parttern.y2 = endy
            this.painter._sendGraphMsg(this.pageStore.shape, this.parttern, 2)
          } else if (this.pageStore.shape === Graphics.CURVE) {
            this.parttern.points = [[endx, endy]]
            this.painter._sendGraphMsg(this.pageStore.shape, this.parttern, 2)
          } else if(this.pageStore.shape === Graphics.GMOV) {
            if (this.moveStatus) {
              this.parttern.ox = endx - canvasDis.x
              this.parttern.oy = endy - canvasDis.y
              this.parttern.graphs = this.graphChildren
              this.painter._sendGraphMsg(Graphics.GMOV, this.parttern)
              canvasDis.x = endx
              canvasDis.y = endy
            } else {
              this.painter.render._drawAllPaint()
              this.boundingRect =  {x1: canvasDis.x, y1: canvasDis.y, x2: endx,y2: endy}
              this.render.drawBoundingRect(this.boundingRect)
            }
          }
        }, 20)()
      }
      document.onmouseup = (e) => {
        document.onmousemove = null;
        document.onmouseup = null;
        // 移动暂时无法撤销
        if (this.pageStore.shape === Graphics.CURVE) {
          // this.parttern.points = [[endx, endy]]
          this.painter._sendGraphMsg(this.pageStore.shape, this.parttern, 5)
        }
        if (this.pageStore.shape !== Graphics.GMOV) {
          this._storeStack(this.pageStore.shape, this.parttern)
        }
        if (this.pageStore.shape === Graphics.GMOV) {
          this.moveStatus = false
          this.render._drawAllPaint()
          if (this.boundingRect) {
            this.graphChildren = this.pageStore.containPaintObj(this.boundingRect)
            this.boundingRect = this.pageStore.groupBoundingRect(this.graphChildren)
            // 绘制包围盒
            this.render.drawBoundingRect(this.boundingRect)
          }
        }
      }
    }
  }
  _storeStack (shape, parttern) {
    let params = {
      type: shape,
    }
    params[shape] = parttern
    this.pageStore.revokeStack.push(params)
  }
  /**
   * 创建图型对象
   */
  _createShapeObject () {
    switch (this.pageStore.shape) {
      case Graphics.LINE: this.parttern = {
          pid: this.pageStore.getCurPage(),
          gid: this.getGraphId(),
          action: null,
          graph: 1,
          brush_size: this.pageStore.brush_size,
          color: this.pageStore.color,
          x1: null,
          y1: null,
          x2: null,
          y2: null

        }
        break;
      case Graphics.CURVE: this.parttern = {
          pid: this.pageStore.getCurPage(),
          gid: this.getGraphId(),
          action: null,
          graph: 2,
          brush_size: this.pageStore.brush_size,
          color: this.pageStore.color,
          points: []
        }
        break;
      case Graphics.TEXT: this.parttern = {
          pid: this.pageStore.getCurPage(),
          gid: this.getGraphId(),
          text: '',
          action: null,
          color: this.pageStore.color,
          left: '',
          top: '',
          right: '',
          bottom: '',
          font: '新宋体',
          fontsize: 20,
        }
        break
      case Graphics.GMOV: this.parttern = {
          pid: this.pageStore.getCurPage(),
          ox: null,
          oy: null,
          graphs: []
      }
    }
  }
  /**
   * 计算横纵坐标
   * @param {*} x 
   * @param {*} y 
   */
  _calcXY (x, y) {
    let { rotateAngle, canvasWidth, canvasHeight } = this.painter
    let points = {}
    if (rotateAngle === 0) {
      points = {
        x: x,
        y: y
      }
    } else if (rotateAngle === 90) {
      points.x = y
      points.y = canvasWidth - x
    } else if (rotateAngle === 180) {
      points.x = canvasWidth - x
      points.y = canvasHeight - y
    } else if (rotateAngle === 270) {
      points.x = canvasHeight - y
      points.y = x
    }
    return {
      x: Math.ceil(this.rate * points.x),
      y: Math.ceil(this.rate * points.y)
    }
  }
  /**
   * 计算输入框相对于画布的横纵坐标
   * @param {*} x 
   * @param {*} y 
   */
  _calcTextDisance (x, y) {
    // 等比适应 坐标不用转换
    if (
      this.painter.displayMode == DisplayMode.DBSY) {
      return {
        x,
        y
      }
    } else {
      return {
        x: Math.ceil(x + (this.painter.parentEle.offsetWidth - this.painter.canvasWidth) / 2),
        y: Math.ceil(y + (this.painter.parentEle.offsetHeight - this.painter.canvasHeight) / 2)
      }
    }
   
  }
  /**
   * 输入框失去焦点事件
   * @param {} e 
   */
  _inputBlurHandle (e) {
    addClass(this.painter.canvasManager.textEle, 'hidden')
    if (!this.parttern.text) return
    this.painter._sendGraphMsg(this.pageStore.shape, this.parttern, 1)
    this._storeStack(this.pageStore.shape, this.parttern)
  }
  /**
   * 输入框事件
   * @param {} e 
   */
  _inputChangeHandle (e) {
    let value = e.target.value
    this.painter.canvasManager.pre.innerText = value
    this.parttern.bottom = this.parttern.top +  this.painter.canvasManager.pre.offsetHeight
    this.parttern.right = this.parttern.left +  this.painter.canvasManager.pre.offsetWidth
    this.parttern.text = value
  }
}